import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(a, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m18.783 15.84-.53-.814H4.106a1 1 0 0 1-1-1V5.5c0-1.053.459-1.928 1.075-2.529C4.781 2.388 5.594 2 6.402 2h11c1.036 0 1.896.417 2.484 1.104.571.669.838 1.536.838 2.396v9.673l.479.823q.82 1.415 1.645 2.826c.188.321.315.689.32 1.064.006.4-.136.89-.598 1.242-.406.308-.924.399-1.437.399h-2.824a1 1 0 1 1 0-2h2.633l-1.937-3.332a1 1 0 0 1-.222-.356M3.804 18.52a1 1 0 1 0-1.706-1.042l-.265.425c-.189.3-.377.6-.548.909-.18.337-.293.723-.285 1.107.008.363.135.832.561 1.183.395.324.898.424 1.39.424h11.358a1 1 0 1 0 0-2H3.19zM16.951 7a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0zm-4 2.323a1 1 0 1 0-2 0V12a1 1 0 1 0 2 0zm-4 1.742a1 1 0 0 0-2 0V12a1 1 0 1 0 2 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: n };
export {
  d as default,
  n as render
};
//# sourceMappingURL=ic_computer_filled-BcccJldg.js.map
